export default {
  storefront_not_found: {
    title: 'No se encontró tienda',
    description: 'Por favor, cree una tienda.',
  },
};
